module.exports = __webpack_public_path__ + "static/media/1.18.3b60e11d.png";